import Plugin from 'src/plugin-system/plugin.class';
// import anime from 'animejs/lib/anime.es.js';
import Swiper from 'swiper/bundle';

export default class ExpertenSliderPlugin extends Plugin {

    init() {

        const swiper = new Swiper('.experten-slider-widget__slider-wrapper', {
            slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            autoHeight: true,
            loop: true,
            centeredSlides: true
        });

        document.addEventListener('Viewport/hasChanged', () => {
            swiper.update();
        });

        // this._resizeImage();
        // this._registerEvents();
    }

    // _registerEvents() {

    //     var that = this;

    //     $( window ).on('resize', () => {
    //         that._resizeImage();
    //     });

    //     $(this.el).find('.experten-slider-widget__more-button').on('click', function(e) {
    //         e.preventDefault();

    //         anime.timeline({ loop: false })
    //             .add({
    //                 targets: '.experten-slider-widget__quote',
    //                 opacity: 0,
    //                 easing: "easeInOutQuad",
    //                 duration: 500,
    //                 complete: function() {
    //                     that._loopElements('.experten-slider-widget__quote', '.is--active');

    //                     anime.timeline({ loop: false })
    //                         .add({
    //                             targets: '.experten-slider-widget__quote',
    //                             opacity: 1,
    //                             easing: "easeInOutQuad",
    //                             duration: 500
    //                         });

    //                     that._resizeImage();
    //                 }
    //             });

    //         anime.timeline({ loop: false })
    //             .add({
    //                 targets: '.experten-slider-widget__name',
    //                 opacity: 0,
    //                 easing: "easeInOutQuad",
    //                 duration: 500,
    //                 complete: function() {
    //                     that._loopElements('.experten-slider-widget__name', '.is--active');

    //                     anime.timeline({ loop: false })
    //                         .add({
    //                             targets: '.experten-slider-widget__name',
    //                             opacity: 1,
    //                             easing: "easeInOutQuad",
    //                             duration: 500
    //                         });

    //                     that._resizeImage();
    //                 }
    //             });

    //         that._loopElements('.experten-slider-widget__image-wrapper', '.is--active');

    //     });
    // }

    // _loopElements(elementSelector, activeSelector) {

    //     var elementClass = elementSelector;
    //     var activeClass = activeSelector.replace(/\./g, "");

    //     var $next = $(elementClass + "." + activeClass).removeClass(activeClass).next(elementClass);
    //     if ($next.length) {
    //         $next.addClass(activeClass);
    //     }
    //     else {
    //         $(elementClass + ":first").addClass(activeClass);
    //     }
    // }

    // _resizeImage() {

    //     //$(this.el).find('.experten-slider-widget__slide').height($(this.el).find('.experten-slider-widget__slide .row').height() + 'px');

    //     var slideHeight = $(this.el).find('.experten-slider-widget__slide').height();
    //     var imageHeight = $(this.el).find('.experten-slider-widget__slide .experten-slider-widget__image').height();
    //     var heightDifference = imageHeight - slideHeight;

    //     anime.timeline({ loop: false })
    //         .add({
    //             targets: '.experten-slider-widget__slider-wrapper',
    //             paddingBottom: heightDifference/2 + 'px',
    //             paddingTop: heightDifference/2 + 'px',
    //             easing: "easeInOutQuad",
    //             duration: 500
    //         });

    //     //$(this.el).find('.experten-slider-widget__slider-wrapper').css('padding-bottom', heightDifference/2 + 'px');
    // }
}
